import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllPersonsFromGroupUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllPersonsFromGroup
  implements GetAllPersonsFromGroupUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllPersonsFromGroupUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllPersonsFromGroupUseCaseInterface.Params,
  ): Promise<GetAllPersonsFromGroupUseCaseInterface.Result> {
    const { groupId, personType } = params;

    const requestUrl = `${this.url}/${groupId}/${personType}`;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
